import { actions } from "./actions";
import { initialState } from "./constants";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOGIN_REQUEST:
      return {
        ...state,
        login: {
          ...state.login,
          loading: true,
          success: false,
          error: null,
        },
      };
    case actions.LOGIN_SUCCESS:
      localStorage.setItem("userInfo", JSON.stringify(action.payload));
      return {
        ...state,
        login: {
          ...state.login,
          loading: false,
          success: true,
        },
      };
    case actions.LOGIN_FAILURE:
      return {
        ...state,
        login: {
          ...state.login,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case actions.CLEAR_FORM_DATA:
      return {
        ...state,
        loginInfo: {
          ...state.loginInfo,
          username: "",
          password: "",
        },
      };
    case actions.UPDATE_FORM_DATA:
      return {
        ...state,
        loginInfo: {
          ...state.loginInfo,
          [action.payload.name]: action.payload.value,
        },
      };
    default:
      return state;
  }
};
